/**
 * Empty development component.
 */

/** Dependencies -------------------------------------------- */

// External

// Internal

import Icon from './icon'

/** Main ---------------------------------------------------- */

const baseClassName = 'empty-development'

export default function EmptyDevelopment() {

    return (
        <div className={ baseClassName }>
            <Icon type="alert" className={ `${baseClassName}__icon` }/>
            <h3 className={ `${baseClassName}__heading` }>No Developments Identified</h3>
            <p className={ `${baseClassName}__message` }>This is good news. Try changing your filter options if you'd like to see developments.</p>   
        </div>
    )
}
